import { adminLink } from "./env"

interface IProps {
  id?: string
  type?: string
  filter?: { [key: string]: any }
  sort?: string
  order?: string
}

export function BuildAdminLink(resource: string, { id, type, filter, sort, order }: IProps): string {
  let url = `${adminLink}#/${resource}`
  if (id) url += `/${id}`
  if (type) url += `/${type}`

  const query = new URLSearchParams()
  if (filter) query.append("filter", JSON.stringify(filter))
  if (sort) {
    query.append("sort", sort)
    query.append("order", order || "ASC")
  }
  if (query.toString()) url += `?${query.toString()}`

  return url
}
